export const accessTokenKeys = {
  list: () => ['access-tokens'] as const,
}
